function getVariantData(id) {
  var container = document.getElementById(id);
  const productVariants = container.querySelector('#productVariants[type="application/json"]');
  if (productVariants) {
    try {
      var data = JSON.parse(productVariants.textContent);

    } catch (error) {
      console.error("Error parsing variant data:", error);
    }
  }
  return data || {};
}

function sumOfVariantsPrice(listPriceName,priceSumId){
  var suma = 0
  var prices = document.querySelectorAll(`.${listPriceName}`)
  var sumPriceCont = document.querySelector(`#${priceSumId}`)
  prices.forEach((priceInput)=>{
     var numberParse = priceInput.value.substring(0,priceInput.value.length - 2 )+'.'+priceInput.value.substring(priceInput.value.length - 2 )
     var number = parseFloat(numberParse)
     suma += number
    })
    sumPriceCont.innerText = `${suma.toFixed(2)}`
}

function setPrice(containerName,inputName,price){
  var priceContainer = document.querySelector(containerName)
  var inputPrice= priceContainer.querySelector(inputName)
  inputPrice.setAttribute("value", price)
}

function setImg(imgContainer,image){
  var elementos = document.querySelectorAll(imgContainer);
  elementos.forEach((element)=>{
    var img = element.querySelector("img")
    img.setAttribute("src",image)
  })
}
function setImgModal(imgContainer,image,listId){
  var imgsProductJson = document.querySelector(listId) 
   var imgsProduct = JSON.parse(imgsProductJson.textContent)
   let listImg = [];
   var startVar = false;
   if(image.includes("https:")){
     var imageCorrect=image.replace("https:","")
   }else{
     var imageCorrect=image
   }
   imgsProduct.forEach((elm)=>{
     if(elm.includes(imageCorrect)){
       startVar = true
     }
     if(startVar && listImg.length<4){
       listImg.push(elm)
     }
   })

  var elementos = document.querySelectorAll(imgContainer);
  elementos.forEach((element)=>{
    var img = element.querySelector("img")
    img.setAttribute("src",image)
     var click = 'showSlideProduct('+ JSON.stringify(listImg) +')' 
     img.setAttribute("onclick",click)
  })
}

function showFirstProduct(id){
  var imgsProductJson = document.querySelector(id) 
  var imgsProduct = JSON.parse(imgsProductJson.textContent)
  var list =[]
  imgsProduct.forEach((img,index)=>{
    if(index<4){
      list.push(img)
    }

  })
  showSlideProduct(list)
}

function zoomImg(elm){
  var divGnrl = document.createElement('div')
  divGnrl.setAttribute('class',"modalGeneral")
  var subDiv = document.createElement('div')
  subDiv.setAttribute('class',"subDivModal")
  var img = document.createElement('img')
  img.setAttribute('src',elm.src)
  
  
  subDiv.append(img)
  divGnrl.append(subDiv)

  var buttonClose = document.createElement('div')
  buttonClose.setAttribute('onclick','closeModal(".modalGeneral")')
  buttonClose.setAttribute('class','close-icon')
  buttonClose.innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
    `
  divGnrl.append(buttonClose)
  var body= document.querySelector("body")
  body.append(divGnrl)
}

function showSlideProduct(list){
  var divGnrl = document.createElement('div')
  divGnrl.setAttribute('class',"modalGeneral")
  var subDiv = document.createElement('div')
  subDiv.setAttribute('class',"subDivModal")
  
  var swiperCont = document.createElement('swiper-container')
  swiperCont.setAttribute("class","mySwiperModal")
 
  swiperCont.setAttribute("mousewheel","true")
  swiperCont.setAttribute("direction","vertical")
  swiperCont.setAttribute("pagination","true")
  list.forEach((elm)=>{
    var swiperSlide = document.createElement('swiper-slide')
    var img = document.createElement('img')
    img.setAttribute('src',elm)
    swiperSlide.append(img)
    swiperCont.append(swiperSlide)
  })
  subDiv.append(swiperCont)
  divGnrl.append(subDiv)

  var buttonClose = document.createElement('div')
  buttonClose.setAttribute('onclick','closeModal(".modalGeneral")')
  buttonClose.setAttribute('class','close-icon')
  buttonClose.innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
    `
  divGnrl.append(buttonClose)
  var body= document.querySelector("body")
  body.append(divGnrl)
}

function closeModal(elm){
  var element = document.querySelector(elm)
  var container = element.parentNode
  container.removeChild(element)
}
